var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReChatWrapper",class:{'isSwitch':this.bIsSwitch}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md col-xl-4 chatSidebar mb-3"},[_c('ReChatSidebar')],1),_c('div',{staticClass:"col chatMain"},[_c('ReChatMain',{attrs:{"chatIsHidden":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }